import { useEffect, useState } from "react";
import api from "../lib/api";
import { Reveal, Eyebrow } from "../components/Reveal";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../components/ui/accordion";
import { useTitle } from "../hooks/useTitle";

export default function Faq() {
  useTitle("FAQ");
  const [faqs, setFaqs] = useState([]);

  useEffect(() => {
    api.get("/faqs").then((r) => setFaqs(r.data)).catch(() => {});
  }, []);

  const categories = [...new Set(faqs.map((f) => f.category || "General"))];

  return (
    <div data-testid="faq-page">
      <section className="bg-[#0A192F] relative overflow-hidden py-16 lg:py-24">
        <div className="absolute inset-0 hero-grid" />
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <Eyebrow light>FAQ</Eyebrow>
          <h1 className="font-display font-extrabold tracking-tight text-white text-3xl sm:text-4xl lg:text-5xl mt-4 max-w-2xl leading-[1.1]">
            Everything you're wondering, answered.
          </h1>
        </div>
      </section>
      <section className="py-16 lg:py-20 max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 space-y-12">
        {categories.map((cat) => (
          <Reveal key={cat}>
            <h2 className="font-display font-extrabold text-lg text-[#0A192F] mb-4 flex items-center gap-3">
              <span className="w-8 h-px bg-[#C59B27]" /> {cat}
            </h2>
            <Accordion type="single" collapsible className="space-y-3">
              {faqs.filter((f) => (f.category || "General") === cat).map((f, i) => (
                <AccordionItem key={f.id} value={`${cat}-${i}`} className="bg-white border border-slate-200 rounded-xl px-5" data-testid={`faq-page-item-${i}`}>
                  <AccordionTrigger className="font-display font-bold text-sm text-[#0A192F] text-left hover:no-underline">
                    {f.question}
                  </AccordionTrigger>
                  <AccordionContent className="text-sm text-[#486581] leading-relaxed">{f.answer}</AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </Reveal>
        ))}
      </section>
    </div>
  );
}
